const GENERATIONS_MOBILE_LAYOUT_KEY = 'generationsMobileSideBySide';

function canUseLocalStorage() {
  try {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  } catch {
    return false;
  }
}

/**
 * @returns {boolean|null} boolean when saved, otherwise null
 */
export function loadGenerationsMobileSideBySidePreference() {
  if (!canUseLocalStorage()) return null;

  try {
    const raw = window.localStorage.getItem(GENERATIONS_MOBILE_LAYOUT_KEY);
    if (raw === null) return null;
    if (raw === 'true') return true;
    if (raw === 'false') return false;
    return null;
  } catch {
    return null;
  }
}

/**
 * @param {boolean} value
 */
export function saveGenerationsMobileSideBySidePreference(value) {
  if (!canUseLocalStorage()) return;

  try {
    window.localStorage.setItem(GENERATIONS_MOBILE_LAYOUT_KEY, String(Boolean(value)));
  } catch {
    // ignore write failures (private mode, quota, etc.)
  }
}

